import React from 'react';

import { ReactComponent as InfoIcon } from '../../../../../assets/icons/info-color-icon-ne.svg';
import { ReactComponent as AlertIcon } from '../../../../../assets/icons/v3/alert-circle.svg';
import { ReactComponent as ErrorCircle } from '../../../../../assets/icons/v3/error-circle.svg';
import { ReactComponent as SuccessIcon } from '../../../../../assets/icons/v3/success.svg';
import { BOX_STATUS } from '../../../../constants/constants';
import { STATUS_BOX_TYPES } from '../../../../types/errorHandlingTypes';

import './StatusBox.scss';

export interface IStatusBoxProps {
  message: string | JSX.Element;
  type: STATUS_BOX_TYPES;
  className?: string;
}

const StatusBox = ({ message, type, className = '' }: IStatusBoxProps) => {
  const loadImage = () => {
    if (type === BOX_STATUS.success) {
      return <SuccessIcon />;
    }
    if (type === BOX_STATUS.error) {
      return <ErrorCircle />;
    }
    if (type === BOX_STATUS.informative) {
      return <InfoIcon />;
    }
    return <AlertIcon />;
  };

  return (
    <div className={`status-box-container ${type} ${className}`}>
      <div className="status-box-icon" data-testid="status-box-icon">
        {loadImage()}
      </div>
      <div className="status-box-message">{message}</div>
    </div>
  );
};

export default StatusBox;
